import request from '@/utils/request'

let EntryApi = {

  /*信息录入列表*/
  list(data) {
    return request._post('/shop/plus.entry.Index/index', data);
},
/*添加信息录入*/
add(data) {
    return request._post('/shop/plus.entry.Index/add', data);
},
/*修改信息录入*/
edit(data) {
    return request._post('/shop/plus.entry.Index/edit', data);
},
/*删除信息录入*/
del(data) {
    return request._post('/shop/plus.entry.Index/del', data);
},
/*信息录入详情*/
detail(data) {
  return request._post('/shop/plus.entry.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.entry.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.entry.Setting/getSetting', data, errorback);
    },
}
export default EntryApi;



// WEBPACK FOOTER //
// ./src/api/entry.js